import { TextField } from "@mui/material";
import SortableEntryWrapper from "./SortableEntryWrapper";

interface InterestRateEntryProps {
  id: string;
  index: number;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onRemove: () => void;
  canRemove: boolean;
  autoFocus?: boolean;
}

export default function InterestRateEntry({
  id,
  index,
  value,
  onChange,
  onRemove,
  canRemove,
  autoFocus,
}: InterestRateEntryProps) {
  return (
    <SortableEntryWrapper id={id} onRemove={onRemove} canRemove={canRemove}>
      <TextField
        label={`Interest Rate ${index + 1} (%)`}
        type="number"
        slotProps={{ htmlInput: { step: 0.01, min: 0 } }}
        value={value ?? ""}
        onChange={(e) =>
          onChange(
            e.target.value === "" ? undefined : parseFloat(e.target.value),
          )
        }
        fullWidth
        margin="none"
        required
        autoFocus={autoFocus}
      />
    </SortableEntryWrapper>
  );
}
